import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { KnBrNacConfigurableComponent } from './kn-br-nac-configurable.component';

@NgModule({
  declarations: [KnBrNacConfigurableComponent],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormsModule,
    FormErrorsModule,
    FileUploadModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrNACConfigurableComponent: {
          component: () => import('./kn-br-nac-configurable.component').then((c) => c.KnBrNacConfigurableComponent),
        },
      },
    } as CmsConfig),
  ],
})
export class KnBrNacConfigurableModule {}
